import { Card, Center, Stack, Text, ThemeIcon, Title, Button, Group } from '@mantine/core';
import { IconClock, IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

/**
 * Bereich ist im Portal angelegt, für diesen Kunden aber noch nicht freigeschaltet.
 *
 * Bewusst kein Fehlerbild: Der Nutzer hat nichts falsch gemacht und ihm fehlt auch
 * kein Recht — der Bereich ist schlicht noch nicht dran. Deshalb ruhige Farben, ein
 * klarer Weg zurück und der Hinweis, wo man nachfragen kann.
 */
export function ComingSoonPage({ title, note }: { title: string; note?: string }) {
  return (
    <Center py={60}>
      <Card withBorder radius="md" p="xl" maw={520} w="100%">
        <Stack align="center" gap="md">
          <ThemeIcon size={56} radius="xl" variant="light" color="orange">
            <IconClock size={30} />
          </ThemeIcon>
          <Stack align="center" gap={4}>
            <Title order={3} ta="center">{title}</Title>
            <Text size="sm" c="dimmed" ta="center">
              Demnächst verfügbar
            </Text>
          </Stack>
          <Text size="sm" c="dimmed" ta="center">
            {note ??
              'Diesen Bereich schalten wir für Sie frei, sobald er fertig ist. Bis dahin erreichen Sie uns wie gewohnt — melden Sie sich einfach bei Ihrem Ansprechpartner.'}
          </Text>
          <Group>
            <Button
              component={Link}
              to="/customer/dashboard"
              variant="light"
              color="orange"
              leftSection={<IconArrowLeft size={16} />}
            >
              Zur Startseite
            </Button>
          </Group>
        </Stack>
      </Card>
    </Center>
  );
}
